"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDefListList = void 0;
const webSearch_1 = require("./webSearch");
const imageGen_1 = require("./imageGen");
const convoTags_1 = require("./convoTags");
const galleryTags_1 = require("./galleryTags");
const detectContactData_1 = require("./detectContactData");
const productCompare_1 = require("./productCompare");
const detectTasks_1 = require("./detectTasks");
const askForVoucher_1 = require("./askForVoucher");
const offerCreator_1 = require("./offerCreator");
const productAPISearch_1 = require("./productAPISearch");
const ragSearch_1 = require("./ragSearch");
const dynamicListings_1 = require("./dynamicListings");
const quickOffer_1 = require("./quickOffer");
const sendContactForm_1 = require("./sendContactForm");
const toolDetector_1 = require("./toolDetector");
const communicationsSearch_1 = require("./communicationsSearch");
const toolDefListList = [
    webSearch_1.webSearchTool,
    imageGen_1.imgTool,
    convoTags_1.convoTagsTool,
    galleryTags_1.galleryTagsTool,
    detectContactData_1.detectContactDataTool,
    productCompare_1.productCompareTool,
    detectTasks_1.detectTasksTool,
    askForVoucher_1.askForVoucherTool,
    offerCreator_1.offerCreatorTool,
    quickOffer_1.quickOfferTool,
    sendContactForm_1.sendContactFormTool,
    productAPISearch_1.productAPISearchTool,
    (0, ragSearch_1.getRagSearchTool)(),
    dynamicListings_1.dynamicListingsTool,
    toolDetector_1.toolDetectorTool,
    communicationsSearch_1.communicationsSearchTool
];
exports.toolDefListList = toolDefListList;
